// src/pages/Messages.jsx
export default function Messages() {
  return <div className="text-white text-center mt-10">messages Page (Home)</div>;
}
